import { EmptyDataAreaInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/empty-data-area-info-box';
import { Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { EmptyPositiveAreaInfoBox } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/info-boxes/empty-positive-area-info-box';
import { useTaxonomyLensContext } from '../common/use-taxonomy-lens-context';
import { TaxonomyIndicatorsInfoBox } from './taxonomy-indicators-info-box';

export function TaxonomyInfoBoxes() {
  const context = useTaxonomyLensContext();
  if (!context?.data.taxonomyKpis) {
    return <></>;
  }
  const text = 'The EU taxonomy indicators only cover positive impacts.';
  return (
    <>
      <EmptyDataAreaInfoBox side={Side.LEFT} text={text} />
      <EmptyPositiveAreaInfoBox />
      <TaxonomyIndicatorsInfoBox />
    </>
  );
}
